import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../../api/analyticsApi';
import { analyticsKeys } from './analyticsKeys';

export const useRevenue = (startDate: string, endDate: string) =>
    useQuery({
        queryKey: analyticsKeys.revenue(startDate, endDate),
        queryFn: () => analyticsApi.getRevenue(startDate, endDate),
        staleTime: 5 * 60 * 1000,
    });
